import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { SubmittedFormsDetailsService } from './submitted-forms-details.service';
import { S3Service } from '../services/s3.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import { Lightbox } from 'ngx-lightbox';
import { PdfViewerModalComponent } from "../pdf-viewer-modal/pdf-viewer-modal.component";
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { ShowOriginalDetailsComponent } from '../show-original-details/show-original-details.component';
import { SharedService } from '../services/shared.service';
import { parsePhoneNumber, AsYouType, isValidPhoneNumber } from 'libphonenumber-js'
import { MatSnackBar } from '@angular/material/snack-bar';
import $ from 'jquery';
import { Constants } from '../Constants';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import { MatSelect } from '@angular/material/select';
import { DashboardService } from '../dashboard/dashboard.service';
import * as FileSaver from 'file-saver';
import { environment } from "../../environments/environment";
import { LoaderService } from '../services/loader.service';
import * as moment from 'moment';


declare var $: any;

interface Food {
	value: string;
	viewValue: string;
}
@Component({
	selector: 'app-submitted-form-details',
	templateUrl: './submitted-form-details.component.html',
	styleUrls: ['./submitted-form-details.component.scss']
})
export class SubmittedFormDetailsComponent implements OnInit {
	selectedValue: string;
	selectedCar: string;
	toppings = new FormControl();
	submittedForm;
	templateSchema;
	topic;
	subtopic;
	actionType;
	template;
	environment = environment
	toppingList: string[] = ['Extra cheese', 'Mushroom', 'Onion', 'Pepperoni', 'Sausage', 'Tomato'];
	editableFields = false;
	saveValidity: Boolean = true;
	foods: Food[] = [
		{ value: 'steak-0', viewValue: 'Steak' },
		{ value: 'pizza-1', viewValue: 'Pizza' },
		{ value: 'tacos-2', viewValue: 'Tacos' }
	];
	base64Pdf;
	subTopicsData = [];
	formResponse;
	bgTextColor = "#000000";
	bgColor = "#fff"
	historyIndex;
	histories = [];
	userPriveleges = [];
	is_read = true;
	formName = "";
	enableAdminNotes = false;
	@ViewChild("teamDropdown") teamDropdown: MatSelect;
	constructor(
		private _lightbox: Lightbox,
		private _submittedFormDetails: SubmittedFormsDetailsService,
		private _activatedRoute: ActivatedRoute,
		private _s3Service: S3Service,
		private domSanitizer: DomSanitizer,
		public dialog: MatDialog,
		private _location: Location,
		private _sharedService: SharedService,
		private _snackBar: MatSnackBar,
		private _router: Router,
		private _dashboardService: DashboardService,
		private _loaderService: LoaderService
	) { }
	@ViewChild('autosize') autosize: CdkTextareaAutosize;
	ngOnInit(): void {
		moment.tz.setDefault(environment.data_time_timezone);
		this.onInit();
	}

	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

	onInit() {
		// Get user privileges
		this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe((response) => {
			if (response['success']) {
			  this.userPriveleges = response['data'][0]['privileges'];
			}
		});
		
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
		if (localStorage.getItem('bgColor')) this.bgColor = localStorage.getItem("bgColor");
		this._activatedRoute.params.subscribe((params) => {
			if (params["id"]) {
				this._submittedFormDetails.getFormDetails(params["id"]).subscribe((response) => {
					if (response['success']) {
						this.submittedForm = response['data'][0];
						this.formName = response['data'][0]['name'] ? response['data'][0]['name'] : Date.now();
						this.templateSchema = response['data'][0]['template_schema']['template_schema']['schema'];
						this.topic = this.submittedForm['topic'] ? (_.isString(this.submittedForm['topic']) ? this.submittedForm['topic'] : Object.values(this.submittedForm['topic'])[0]) : '';
						this.subtopic = this.submittedForm['subtopic'] ? (_.isString(this.submittedForm['subtopic']) ? this.submittedForm['subtopic'] : Object.values(this.submittedForm['subtopic'])[0]) : '';
						this.formResponse = response["data"][0]["response"];
						this.template = response['data'][0]['template']
						let history = {
							submittedBy: _.cloneDeep(this.submittedForm.submittedBy),
							updated_at: _.cloneDeep(this.submittedForm.updated_at),
							response: _.cloneDeep(this.submittedForm.response)
						};
						if (!this.submittedForm.history || !(this.submittedForm.history.length > 0)) {
							this.submittedForm.history = [];
						}
						this.submittedForm.history.push(_.cloneDeep(history));
						this.historyIndex = this.submittedForm.history.length - 1;
						this.histories = _.cloneDeep(this.submittedForm.history);
						this.histories.push(_.cloneDeep(history));

						this.parseTemplate();
						this.makeFormRead(params["id"], "init");
						if(this.templateSchema && this.templateSchema.length > 0) {
							this.templateSchema.forEach((field) => {
								if(field.type && field.type == "address")  {
									field.data = {}
								}
							})
						}
					}
				});
			}
			if (params["actionType"]) {
				this.actionType = params["actionType"];
				if(params['actionType'] == "FileCabinet") {
					this.actionType = "Storage"
				}
			}
		});
	}

	makeFormRead(formId?, from?) {
		let requestDetails = {}
		if(from && from == "init") {
			requestDetails['formId'] =  formId
			requestDetails["is_read"] = true
		} else {
			requestDetails['formId'] =  this.submittedForm._id
			requestDetails["is_read"] = false
			this.is_read = false
		}
		this._submittedFormDetails.makeFormRead(requestDetails).subscribe(response => {
			if(requestDetails && requestDetails['is_read'] != true) {
				this.navToActionListPage()
			}
		})
	}

	onInsurance(event, element) {
		if (element.raw_images) {
			let attachmentsLength = element.raw_images.length + event.target.files.length;
			if (attachmentsLength > 5) {
				if (element["type"] === "picture") {
					element.error = "Only five picture uploads are allowed per field";
				} else {
					element.error = "Only five file uploads are allowed per field";
				}
				return;
			}
		}
		if (event.target.files && event.target.files[0] && element["type"] === 'picture') {
			if(!Constants.acceptedImageTypes.includes(event.target.files[0].type)) {
				element.error = "Invalid image format. Please upload only JPEG, PNG, WEBP images.";
				return;
			}
			if (!element['picture_files']) element['picture_files'] = [];
			if (!element['raw_images']) element['raw_images'] = [];
			var filesAmount = event.target.files.length;
			for (let i = 0; i < filesAmount; i++) {
				if (event.target.files[i]["size"] > 5000000) {
					element["error"] = "File size cannot exceed 5MB";
					return;
				}
			}

			for (let i = 0; i < filesAmount; i++) {
				var reader = new FileReader();
				reader.onload = (event: any) => {
					//console.log(event.target.result);
					let image = event.target.result;
					element['raw_images'].push({ src: image, thumb: image, index: (element["raw_images"].length + i) });
				}
				reader.readAsDataURL(event.target.files[i]);
				element['picture_files'].push(event.target.files[i]);
			}
		}

		if (event.target.files && event.target.files[0] && element["type"] === 'file') {
			if(!Constants.acceptedFileTypes.includes(event.target.files[0].type)) {
				element.error = "Invalid file type. Only PDF is allowed.";
				return;
			}
			if (!element['picture_files']) element['picture_files'] = [];
			if (!element['raw_images']) element['raw_images'] = [];
			var filesAmount = event.target.files.length;
			for (let i = 0; i < filesAmount; i++) {
				if (event.target.files[i]["size"] > 5000000) {
					element["error"] = "File size cannot exceed 5MB";
					return;
				}
			}
			
			for (let i = 0; i < filesAmount; i++) {
				var reader = new FileReader();
				reader.onload = (event: any) => {
					let image = event.target.result.split(',')[1];
					element['raw_images'].push({ src: this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(image).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'}))), thumb: this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(image).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'}))), index: (element["raw_images"].length + i)});
				}
				reader.readAsDataURL(event.target.files[i]);
				element['picture_files'].push(event.target.files[i]);
			}
		}

		let templateIndex = this.templateSchema.findIndex((elementObj) => elementObj.key === element.key);
		this.templateSchema[templateIndex]["error"] = "";
		const input = document.getElementById(element.key);
		input["value"] = null;
	}

	deletePicture(element, index) {
		let pictureIndex = element.value.findIndex((picture) => picture === element["raw_images"][index]["key"]);
		element["value"].splice(pictureIndex, 1);
		if (element["picture_files"]) {
			element['picture_files'].splice(index, 1);
		}
		element['raw_images'].splice(index, 1);
		this.submittedForm.response[element.key].splice(index, 1);
		element.error = "";
	}

	deleteFile(element, index) {
		let fileIndex = element.value.findIndex((file) => file === element["raw_images"][index]["key"]);
		element['value'].splice(fileIndex, 1);
		element['raw_images'].splice(index, 1);
		if (element["picture_files"]) {
			element['picture_files'].splice(index, 1);
		}
		this.submittedForm.response[element.key].splice(index, 1);
		element.error = "";
	}

	open(index: number, images): void {
		// open lightbox
		this._lightbox.open(images, index);
	}

	viewFile(index: number, file): void {
		const dialogRef = this.dialog.open(PdfViewerModalComponent, {
			width: '800px',

			data: {
				file: file[index]["src"]
			}
		});
	}

	close(): void {
		// close lightbox programmatically
		this._lightbox.close();
	}

	getValue(element) {
		if (this.submittedForm.response && this.submittedForm.response[element.key] && element.value) {
			const selectedItem = element.data.find(c => c.label === Object.values(element.value)[0]);
			return selectedItem;
		} else if (element.type !== 'topic' || element.type !== 'subtopic' || !this.submittedForm.response[element.key] && !element.value) {
			return "";
		}
		return element.data[0];
	}

	onFieldChange(key, value, type) {

		if (type === 'question' || type === 'checkbox') {
			if (value === 'true') {
				value = true;
				this.submittedForm["response"][key] = value;
			}
			if (value === 'false') {
				value = false;
				this.submittedForm["response"][key] = value;
			}
		}
		if (type === 'select') {
			var selectData = {};
			selectData[value.value] = value.label;
			value = selectData;
		}

		if (type === "contact") {
			// this.saveValidity = false;
			let index = this.templateSchema.findIndex((element) => element.key === key);
			if (value === "yes") {
				if (this.submittedForm["response"][key]) {
					this.submittedForm["response"][key]["requested"] = true;
				} else {
					this.submittedForm["response"][key] = {
						requested: true,
						email: "",
						phone: ""
					}
				}
				if (this.templateSchema[index]["value"]) {
					this.templateSchema[index]["value"]["requested"] = true;
				}  else {
					this.templateSchema[index]["value"] = {
						requested : true,
						email: "",
						phone: ""
					}
				}
			} else {
				if (this.submittedForm["response"][key]) {
					this.submittedForm["response"][key]["requested"] = false;
				}  else {
					this.submittedForm["response"][key] = {
						requested : false,
						email: "",
						phone: ""
					}
				}
				if (this.templateSchema[index]["value"]) {
					this.templateSchema[index]["value"]["requested"] = false;
				}  else {
					this.templateSchema[index]["value"] = {
						requested : false,
						email: "",
						phone: ""
					}
				}
			}
			value = {
				requested: this.submittedForm["response"][key]["requested"],
				email: "",
				phone: ""
			}
		}

		if(type == "address") {
			let index = this.templateSchema.findIndex((element) => element.key === key);
			let obj = {
				address: "",
				city: "",
				state: "",
				zipcode: "",
				requested: (value === "yes") ? true : false
			}
			// this.formResponse[key] = obj;
			if(value == "yes") {
				if(this.submittedForm["response"][key]) {
					this.submittedForm["response"][key]["requested"] = true;
				} else {
					this.submittedForm["response"][key] = {
						address: "",
						city: "",
						state: "",
						zipcode: "",
						requested: true
					}
				}
				if (this.templateSchema[index]["value"]) {
					this.templateSchema[index]["value"]["requested"] = true;
				}  else {
					this.templateSchema[index]["value"] = obj;
				}
			} else if(value == "no") {
				if(this.submittedForm["response"][key]) {
					this.submittedForm["response"][key]["requested"] = false;
				} else {
					this.submittedForm["response"][key] = {
						address: "",
						city: "",
						state: "",
						zipcode: "",
						requested: false
					}
				}
				if (this.templateSchema[index]["value"]) {
					this.templateSchema[index]["value"]["requested"] = false;
				}  else {
					this.templateSchema[index]["value"] = {
						requested : false,
						address: "",
						city: "",
						state: "",
						zipcode: "",
					}
				}
			}
			value = {
				requested: this.submittedForm["response"][key]["requested"],
				address: "",
				city: "",
				state: "",
				zipcode: "",
			}
		}

		if (key === 'topic') {
			const subTopicsFieldData = this.templateSchema.find(c => c.key === 'subtopic');
			const topicId = String((Object.keys(this.formResponse['topic']))[0]);
			this.subTopicsData = subTopicsFieldData.dependent_data[topicId];	
		}

		if(type == "admin_notes") {
			this.enableAdminNotes = true;
		}

		this.submittedForm.response[key] = value;
		let templateIndex = this.templateSchema.findIndex((element) => element.key === key);
		this.templateSchema[templateIndex]["error"] = "";
	}

	onSelectionChange(key, value, type, event) {
		if (key === 'topic') {
			var selectData = {};
			let topicData = value;
			selectData[value.value] = value.label;
			value = selectData;
			this.submittedForm.response[key] = value;
			let topicKey = Object.keys(value);
			this.topic = value[topicKey[0]];
			this.subTopicsData = topicData["options"]
			this.submittedForm.response["subtopic"] = {};
			this.subtopic = "";
			if (this.subTopicsData.length === 0) {
				this.subtopic = "No subtopics available"
			}
			if (this.formResponse["subtopic"]) {
				delete this.formResponse["subtopic"]; // Deleting subtopic selection
			}
			let index = this.templateSchema.findIndex((element) => element.key === key);
			this.templateSchema[index]["error"] = ""
			this.teamDropdown.value = null;
		} else {
			var selectData = {};
			selectData[value.value] = value.label;
			this.subtopic = value.label;
			value = selectData;
			this.submittedForm.response[key] = value;
			let index = this.templateSchema.findIndex((element) => element.key === key);
			this.templateSchema[index]["error"] = ""
		}

		// if (type === 'select') {
		// 	var selectData = {};
		// 	selectData[value.value] = value.label;
		// 	value = selectData;
		// }

		// this.submittedForm.response[key] = value;
	}


	onSave() {

		if (this.saveValidity) {
			let validity = true;
			const formData: FormData = new FormData();
			formData.append('history', JSON.stringify(this.submittedForm.history));
			let topicsExist = true;
			let attachements = {}
			this.templateSchema.forEach(element => {
				if (element.picture_files) {
					if (!this.submittedForm.response[element.key]) this.submittedForm.response[element.key] = [];
					attachements[element.key]= []
					_.forEach(element.picture_files, (image, index) => {
						const file: File = image;
						const fileName = element.key + '_' + index;
						if (!_.includes(attachements[element.key], fileName)) {
							// this.formResponse[element.key].push(fileName);
							formData.append(fileName, file);
							attachements[element.key].push(fileName)
						}
					});
				} 
				if (element.key === 'employeename') {
					if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.key === "topic") {
					if (element.data.length === 0) {
						topicsExist = false;
						return false;
					}
					if (!this.submittedForm.response[element.key] || this.submittedForm.response[element.key].length === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.key === "subtopic") {
					if (topicsExist) {
						let topic = "";
						if (!this.submittedForm.response["topic"]) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
						if (this.submittedForm.response["topic"] && Object.keys(this.submittedForm.response["topic"])[0]) {
							topic= Object.keys(this.submittedForm.response["topic"])[0];
						}
						if (element.dependent_data) {
							let subtopics = element.dependent_data[topic];
							if (subtopics.length > 0) {
								if (!this.submittedForm.response[element.key] || this.submittedForm.response[element.key].length  === 0) {
									this.openResubmitToast();
									element.error = "This is a mandatory field";
									validity = false;
									return false;
								}
							}
						}
					}
				} else if (element.key === "subject") {
					if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
						this.openResubmitToast();
						element.error = "This is a mandatory field";
						validity = false;
						return false;
					}
				} else if (element.type === "text" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key] && this.formResponse[element.key].length > element.validate.maxlength) {
						this.openResubmitToast();
						element.error = "This field should not contain more than 50 characters";
						validity = false;
						return false;
					}
				} else if (element.type === "textarea" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key] && this.formResponse[element.key].length > element.validate.maxlength) {
						this.openResubmitToast();
						element.error = "This field should not contain more than 350 characters";
						validity = false;
						return false;
					}
				} else if (element.type === "email" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (this.formResponse[element.key]) {
						let email = this.formResponse[element.key];
						let regex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
						if (!regex.test(email)) {
							element.error = "Enter valid email address"
							validity = false;
							this.openResubmitToast();
							return false;
						}
					}
				} else if (element.type === "phone" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key] || this.formResponse[element.key].length === 0) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							this.openResubmitToast();
							return false;
						}
					}
					if (this.formResponse[element.key]) {
						try {
							let phone = parsePhoneNumber(this.formResponse[element.key], "US");
							let nationalNumber = phone.formatNational();
							let regex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
							if (!regex.test(nationalNumber)) {
								element.error = "Enter valid phone number"
								validity = false;
								this.openResubmitToast();
								return false;
							} else {
								let phone = parsePhoneNumber(this.formResponse[element.key], "US");
								this.formResponse[element.key] = phone.number;
							}
						} catch (error) {
							element.error = "Enter valid phone number";
							validity = false;
							this.openResubmitToast();
							return false;
						}
						
					}
				} else if (element.type === "radio" && element.visible) {
					if (element.validate.required) {
						if (!this.formResponse[element.key]) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "checkbox" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "select" && element.key !== "subtopic" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "picture" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse) || (!element.raw_images || !(element.raw_images.length > 0))) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "file" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse) || (!element.raw_images || !(element.raw_images.length > 0))) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "question" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "contact" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
					if (element.key in this.formResponse) {
						if (this.formResponse[element.key].requested) {
							if (this.formResponse[element.key].email.length === 0) {
								let templateIndex = this.templateSchema.findIndex((field) => field.key === element.key);
								this.templateSchema[templateIndex]["data"]["emailError"] = "Enter valid email address";
								validity = false;
								this.openResubmitToast();
							} else {
								let templateIndex = this.templateSchema.findIndex((field) => field.key === element.key);
								let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
								let valid = emailRegex.test(String(this.formResponse[element.key].email).toLowerCase());
								if(!valid) {
									this.templateSchema[templateIndex]["data"]["emailError"] = "Enter valid email address";
									validity = false;
									this.openResubmitToast();
									// return false;
								}
							}
							if (this.formResponse[element.key].phone.length === 0) {
								let templateIndex = this.templateSchema.findIndex((field) => field.key === element.key);
								this.templateSchema[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
								validity = false;
								this.openResubmitToast();
							} else {
								let templateIndex = this.templateSchema.findIndex((field) => field.key === element.key);
								try {
									let phone = parsePhoneNumber(this.formResponse[element.key].phone, "US");
									const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
									let nationalNumber = phone.formatNational();
									let valid = re.test(nationalNumber);
									if(!valid) {
										this.templateSchema[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
										validity = false;
										this.openResubmitToast();
										// return false;
									}
								} catch (error) {
									this.templateSchema[templateIndex]["data"]["phoneError"] = "Enter valid phone number";
									validity = false;
									this.openResubmitToast();
								}
								
							}
						}
					}
				} else if(element.type == "address" && element.visible) {
					// if (element.validate.required) {
					// 	if (!(element.key in this.formResponse)) {
					// 		this.openResubmitToast();
					// 		element.error = "This is a mandatory field";
					// 		validity = false;
					// 		return false;
					// 	}
					// }
					let templateIndex = this.templateSchema.findIndex((field) => field.key === element.key);
					if(element.validate.required) {
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['address'] || this.formResponse[element.key]['address'].length == 0) {
							this.templateSchema[templateIndex]["data"]['addressError'] = "Enter valid Street Address";
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['city'] || this.formResponse[element.key]['city'].length == 0) {
							this.templateSchema[templateIndex]["data"]['cityError'] = "Enter valid City name"
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['state'] || this.formResponse[element.key]['state'].length == 0) {
							this.templateSchema[templateIndex]["data"]['stateError'] = "Enter valid Zip"
							validity = false;
							this.openResubmitToast();
							// return false;
						} 
						if(!(element.key in this.formResponse) || !this.formResponse[element.key]['zipcode'] || this.formResponse[element.key]['zipcode'].length == 0) {
							this.templateSchema[templateIndex]["data"]['zipcodeError'] = "This is a mandatory field"
							validity = false;
							this.openResubmitToast();
							// return false;
						}
					}
					if(element.key in this.formResponse) {
						if(this.formResponse[element.key]['zipcode'] && this.formResponse[element.key]['zipcode'].length == 0) {
							this.templateSchema[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
							validity = false;
							this.openResubmitToast();
							// return false;
						} else if(this.formResponse[element.key]['zipcode']) {
							let zipCodeValidator = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
							if(!zipCodeValidator.test(this.formResponse[element.key]['zipcode'])) {
								this.templateSchema[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
								validity = false;
								this.openResubmitToast();
							}
						}
					}
				} else if (element.type === "date" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				} else if (element.type === "time" && element.visible) {
					if (element.validate.required) {
						if (!(element.key in this.formResponse)) {
							this.openResubmitToast();
							element.error = "This is a mandatory field";
							validity = false;
							return false;
						}
					}
				}
			});
			if (validity) {
				if(attachements && Object.keys(attachements).length > 0) {
					Object.keys(attachements).forEach(key => {
						if(this.submittedForm.response[key] && this.submittedForm.response[key].length > 0) {
							if(attachements[key] && attachements[key].length > 0)
								this.submittedForm.response[key].push(...attachements[key])
						} else {
							this.submittedForm.response[key] = attachements[key]
						}
					})
				}
				formData.append('formId', this.submittedForm._id);
				formData.append('formSubmittedBy', this.submittedForm.response["employeename"]);
				formData.append('formResponse', JSON.stringify(this.submittedForm.response));
				formData.append('formTopic', JSON.stringify(this.submittedForm.response.topic ? this.submittedForm.response.topic : ""));
				formData.append('formSubTopic', JSON.stringify((this.submittedForm.response.subtopic) ? this.submittedForm.response.subtopic : ''));
				formData.append('template', this.template)
				if(this.template == environment.help_form_id) {
					formData.append('updated_by', JSON.stringify({ 
						username:localStorage.getItem('username'),
						user_id: localStorage.getItem('userId'),
						organization_id: localStorage.getItem('organization')
					}))
				}
				
				this._submittedFormDetails.updateFormDetails(formData).subscribe((response) => {
					if (response['success']) {
						if (localStorage.getItem('email')) {
							this.openSnackBar("Form updated successfully");
							this.editableFields = false;
							this.enableAdminNotes = false;
							this.onInit();
						}
					}
				});
			}
		}
	}

	navToActionListPage() {
		this._location.back();
	}

	originalDetails() {
		document.body.classList.add('modal-open');
		const dialogRef = this.dialog.open(ShowOriginalDetailsComponent, {
			data: this.submittedForm.history
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res && res.res && res.res.response) {
				// this.submittedForm.response = [];
				// this.submittedForm.response = _.cloneDeep(res.res.response);
				// this.submittedForm.topic = res.res.response.topic;
				// this.submittedForm.sutopic = res.res.response.subtopic;
				// this.topic = (res.res.response.topic) ? Object.values(res.res.response.topic)[0]: "";
				// this.subtopic = (res.res.response.subtopic)? Object.values(res.res.response.subtopic)[0]: "";
				// this.historyIndex = res.historyIndex;
				// this.parseTemplate();
				this.submittedForm.response = [];
				this.submittedForm.response = _.cloneDeep(this.histories[res.historyIndex].response);
				this.submittedForm.topic = this.histories[res.historyIndex].response.topic;
				this.submittedForm.sutopic = this.histories[res.historyIndex].response.subtopic;
				this.topic = (this.histories[res.historyIndex].response.topic) ? Object.values(this.histories[res.historyIndex].response.topic)[0]: "";
				this.subtopic = (this.histories[res.historyIndex].response.subtopic)? Object.values(this.histories[res.historyIndex].response.subtopic)[0]: "";
				this.historyIndex = res.historyIndex;
				this.parseOldTemplate();
			}
			document.body.classList.remove('modal-open');
		})
	}

	onCancel() {
		this.editableFields = false;
		this.enableAdminNotes = false;
		this.submittedForm.response = [];
		this.submittedForm.response = _.cloneDeep(this.histories[this.historyIndex].response);
		this.submittedForm.topic = this.histories[this.historyIndex].response.topic;
		this.submittedForm.sutopic = this.histories[this.historyIndex].response.subtopic;
		this.topic = (this.histories[this.historyIndex].response.topic) ? Object.values(this.histories[this.historyIndex].response.topic)[0]: "";
		this.subtopic = (this.histories[this.historyIndex].response.subtopic)? Object.values(this.histories[this.historyIndex].response.subtopic)[0]: "";
		this.parseOldTemplate();
	}

	onContactInputChange(key, type, value) {
		if (type === 'email') {
			this.formResponse[key]["email"] = value;
			this.submittedForm.response[key]["email"] = this.formResponse[key]["email"];
		} else {
			this.formResponse[key]["phone"] = new AsYouType('US').input(value);
			this.submittedForm.response[key]["phone"] = this.formResponse[key]["phone"];
			let index = this.templateSchema.findIndex((element) => element.key === key);
			this.templateSchema[index]["data"]["phone"] = this.formResponse[key]["phone"];
		}
		$('.numbersOnly').keyup(function () {
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
	}

	onPhoneInputChange(value, key) {
		$('.numbersOnly').keyup(function () { 
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
		this.formResponse[key] = new AsYouType('US').input(value);
		this.submittedForm.response[key] = this.formResponse[key];
		let index = this.templateSchema.findIndex((element) => element.key === key);
		this.templateSchema[index]["value"] = this.formResponse[key];
	}

	openResubmitToast() {
		this._sharedService.openSnackBar(Constants.status.resubmit);
	}

	onContactInputBlur(key, type) {
		if (type === 'email') {
			let email = this.formResponse[key]["email"];
			const re = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/;
			let valid = re.test(String(email).toLowerCase());
			if (!valid) {
				let index = this.templateSchema.findIndex((element) => element.key === key);
				this.templateSchema[index]["data"]["emailError"] = "Enter valid email address";
				this.saveValidity = false;
			} else {
				let index = this.templateSchema.findIndex((element) => element.key === key);
				this.templateSchema[index]["data"]["emailError"] = "";
				this.saveValidity = true;
			}
		} else {
			let index = this.templateSchema.findIndex((element) => element.key === key);
			try {
				let phone = parsePhoneNumber(this.formResponse[key]["phone"], "US");
				const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
				let nationalNumber = phone.formatNational();
				let valid = re.test(nationalNumber);
				if (!valid) {
					this.templateSchema[index]["data"]["phoneError"] = "Enter valid phone number";
					this.saveValidity = false;
				} else {
					// this.formResponse[key]["phone"] = phone.number;
					this.templateSchema[index]["data"]["phoneError"] = "";
					this.submittedForm.response[key]["phone"] = this.formResponse[key]["phone"];
					this.saveValidity = true;
				}
			} catch(error) {
				this.templateSchema[index]["data"]["phoneError"] = "Enter valid phone number";
				this.saveValidity = false;
			}
			
		}
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000
		});
	}

	parseTemplate() {
		this.templateSchema.forEach(element => {
			element.error = "";
			for (let i = 0; i < Object.keys(this.submittedForm.response).length; i++) {
				if (this.submittedForm.response[element.key] !== undefined) {
					element["value"] = this.submittedForm.response[element.key];
					if (!this.submittedForm.response[element.key]) {
						element["value"] = "";
					}
					if (element.type === 'radio' || element.type === 'question') {
						if(!element.value) {
							element.value = false;
						}
						for (let j = 0; j < element.data.length; j++) {
							if (element.data[j].value === element.value) {
								element.data[j]["checked"] = true;
							} else {
								element.data[j]["checked"] = false;
							}
						}
					} else if (element.type === 'select') {
						for (let j = 0; j < element.data.length; j++) {
							if (element.data[j].label === element.value) {
								element.data[j]["checked"] = true;
							} else {
								element.data[j]["checked"] = false;
							}
						}
					} else if (element.type === 'contact') {
						if (element.value && element.value["requested"]) {
							let parsedPhone = parsePhoneNumber(element.value['phone'], "US")
							element.value['phone'] = parsedPhone.formatNational();
							element.data["phone"] = parsedPhone.formatNational();
						}
					} else if (element.type === 'phone') {
						if (element.value) {
							let parsedPhone = parsePhoneNumber(element.value, "US")
							element.value = parsedPhone.formatNational();
						}
					}
				} else {
					delete element["value"];
				}
			}
			if (element.type === 'picture') {
				element["raw_images"] = [];
				if (element["value"] && element["value"].length > 0) {
					element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
					element["raw_images"] = [];
					for (let j = 0; j < element["value"].length; j++) {
						element["raw_images"].push({ src: "", thumb: "", index: j, key: element["value"][j], loading: true });
						this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
							var binary = '';
							var bytes = new Uint16Array(response['data']);
							var len = bytes.byteLength;
							for (var i = 0; i < len; i++) {
								binary += String.fromCharCode(bytes[i]);
							}
							let image = "data:image/jpeg;base64," + window.btoa(binary);
							element["raw_images"][j]["src"] = image;
							element["raw_images"][j]["loading"] = false;
						}, (error) => {
							console.log(error);
						});
					}
				}
			} else if (element.type === 'file') {
				element["raw_images"] = [];
				if (element["value"] && element["value"].length > 0) {
					element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
					// element["raw_images"] = _.cloneDeep(element["value"]);
					element["raw_images"] = [];
					for (let j = 0; j < element["value"].length; j++) {
						element["raw_images"].push({ src: "", index: j, key: element["value"][j], loading: true });
						this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
							var binary = '';
							var bytes = new Uint8Array(response["data"]);
							var len = bytes.byteLength;
							for (var i = 0; i < len; i++) {
								binary += String.fromCharCode(bytes[i]);
							}
							const url = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(window.btoa(binary)).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'})));
							element["raw_images"][j]["src"] = url;
							element["raw_images"][j]["loading"] = false;
						}, (error) => {
							console.log(error);
						});
					}
				}
			}
		});
	}

	parseOldTemplate() {
		let template = _.cloneDeep(this.templateSchema);
		let promises = [];
		template.forEach(element => {
			element.error = "";
			for (let i = 0; i < Object.keys(this.submittedForm.response).length; i++) {
				if (this.submittedForm.response[element.key] !== undefined) {
					element["value"] = this.submittedForm.response[element.key];
					if (!this.submittedForm.response[element.key]) {
						element["value"] = "";
					}
					if (element.type === 'radio' || element.type === 'question') {
						if(!element.value) {
							element.value = false;
						}
						for (let j = 0; j < element.data.length; j++) {
							if (element.data[j].value === element.value) {
								element.data[j]["checked"] = true;
							} else {
								element.data[j]["checked"] = false;
							}
						}
					} else if (element.type === 'select') {
						for (let j = 0; j < element.data.length; j++) {
							if (element.data[j].label === element.value) {
								element.data[j]["checked"] = true;
							} else {
								element.data[j]["checked"] = false;
							}
						}
					} else if (element.type === 'contact') {
						if (element.value && element.value["requested"]) {
							let parsedPhone = parsePhoneNumber(element.value['phone'], "US")
							element.value['phone'] = parsedPhone.formatNational();
						}
					} else if (element.type === 'phone') {
						if (element.value) {
							let parsedPhone = parsePhoneNumber(element.value, "US")
							element.value = parsedPhone.formatNational();
						}
					}
				} else {
					delete element["value"];
				}
			}
			if (element.type === 'picture') {
				element["raw_images"] = [];
				if (element["value"] && element["value"].length > 0) {
					element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
					element["raw_images"] = [];
					for (let j = 0; j < element["value"].length; j++) {
						promises.push(this.getObjectFromS3(element["value"][j], element["key"], element["type"], j));
					}
				}
			} else if (element.type === 'file') {
				element["raw_images"] = [];
				if (element["value"] && element["value"].length > 0) {
					element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
					// element["raw_images"] = _.cloneDeep(element["value"]);
					element["raw_images"] = [];
					for (let j = 0; j < element["value"].length; j++) {
						promises.push(this.getObjectFromS3(element["value"][j], element["key"], element["type"], j));
					}
				}
			}
		});
		if (promises.length > 0) {
			Promise.all(promises).then((attachments) => {
				attachments.forEach((element) => {
					let index = template.findIndex((field) => field.key === element.key);
					template[index]["raw_images"].push(element.attachment);
				});
				this.templateSchema = [];
				this.templateSchema = _.cloneDeep(template);	
			})
		} else {
			this.templateSchema = [];
			this.templateSchema = _.cloneDeep(template);	
		}
	}

	getObjectFromS3(key, element_key, type, index) {
		return new Promise((resolve, reject) => {
			this._s3Service.getObjectFromKey(key).subscribe((response) => {
				var binary = '';
				var bytes = new Uint16Array(response['data']);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					binary += String.fromCharCode(bytes[i]);
				}
				let format = "";
				if (type === "picture") {
					format = "data:image/jpeg;base64,";
					let image = format + window.btoa(binary);
					resolve({ key: element_key, attachment: { src: image, thumb: image, index: index, key: key }})
				} else {
					format = "data:application/pdf;base64,";
					// let pdf = format + window.btoa(binary);
					let url = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(window.btoa(binary)).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'})));
					resolve({ key: element_key, attachment: { src: url, index: index, key: key }})
				}
			}, (error) => {
				console.log(error);
				reject("Error retrieving data");
			});
		})
	}

	edit() {
		this.editableFields = !this.editableFields;
		if (!this.editableFields) {
			this.onInit();
		}
	}

	navToHome(): void {
		let url = ""
		let userPrevilages = this.userPriveleges
		url = this._router.serializeUrl(this._router.createUrlTree(['/dashboard']));
		this._router.navigate([url]);

	}

	deleteSubmittedForm() {
		// this._sharedService.confirmationDialog("Are you sure you want to delete the form?", () => {
			let requestData = {
				formId: this.submittedForm._id,
				template: this.template
			};
			if(this.template == environment.help_form_id) {
				requestData['deleted_by'] = { 
					username:localStorage.getItem('username'),
					user_id: localStorage.getItem('userId'),
					organization_id: localStorage.getItem('organization')
				}
			}
			this._dashboardService.deleteSubmittedForm(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar("Form deleted successfully");
					// this._router.navigateByUrl("dashboard");
					this.navToActionListPage();
				} else {
					this.openSnackBar("Error occurred while deleting the form. Please try again later");
				}
			}, (error) => {
				console.log(error);
			});
		// });
	}
	
	archiveSubmittedForm() {
		// this._sharedService.confirmationDialog("Are you sure you want to archive the form?", () => {
			let requestData = {
				formId: this.submittedForm._id,
				template: this.template
			};

			if(this.template == environment.help_form_id) {
				requestData['updated_by'] = { 
					username:localStorage.getItem('username'),
					user_id: localStorage.getItem('userId'),
					organization_id: localStorage.getItem('organization')
				}
			}

			this._dashboardService.archiveSubmittedForm(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar("Form archived successfully");
					// this._router.navigateByUrl("dashboard");
					this.navToActionListPage()
				} else {
					this.openSnackBar("Error occurred while archiving the form. Please try again later");
				}
			}, (error) => {
				console.log(error);
			});
		// });
	}

	checkPrivilege(accessType) {
		return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
	}

	print() {
		this._activatedRoute.params.subscribe((params) => {
			this._submittedFormDetails.printForm(params["id"]).subscribe(response => {
				if(response['success']) {
					this._loaderService.changeLoadingVisibility(true);
					const iframe = document.createElement('iframe');
					iframe.id = params["id"];
					iframe.style.display = 'none';
					document.body.appendChild(iframe);
					
					let qrElement: any = document.getElementById("qr-element");
					qrElement = qrElement?.firstChild?.firstChild?.src
					
					iframe.srcdoc = response['html'];
					setTimeout(() => {
						iframe.contentWindow?.print();
						this._loaderService.changeLoadingVisibility(false);
						iframe.remove();
					}, 1500)
							
				}
			}, error => {
				this._loaderService.changeLoadingVisibility(false);
				console.log(error)
			})
		})
	}

	onAddressInput(key, type, value) {
		let templateIndex = this.templateSchema.findIndex((element) => element.key === key);
		if(!this.formResponse[key] || this.formResponse[key] === undefined) {
			this.formResponse[key] = {}
		}
		if(type == "address") {
			this.formResponse[key]["address"] = value;
			this.templateSchema[templateIndex]["data"]['addressError'] = ""
		} else if(type == "city") {
			this.formResponse[key]["city"] = value;
			this.templateSchema[templateIndex]["data"]['cityError'] = ""
		} else if(type == "state") {
			this.formResponse[key]["state"] = value;
			this.templateSchema[templateIndex]["data"]['stateError'] = ""
		} else if(type == "zipcode") {
			this.formResponse[key]["zipcode"] = value;
			this.templateSchema[templateIndex]["data"]['zipcodeError'] = ""
		}

		$('.numbersOnly').keyup(function () { 
			this.value = this.value.replace(/[^0-9()\-. ]/g,'');
		});
	}

	onAddressBlur(key, type) {
		let templateIndex = this.templateSchema.findIndex((element) => element.key === key);
		if(!this.formResponse[key] || this.formResponse[key] === undefined) {
			this.formResponse[key] = {}
		}
		let value = this.formResponse[key][type];
		let zipCodeValidator = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
		if(type == "address" && ((!value || value.length == 0))) {
			this.templateSchema[templateIndex]["data"]['addressError'] = "Enter valid Address/Flat no"
		} else if(type == "city" && ((!value || value.length == 0))) {
			this.templateSchema[templateIndex]["data"]['cityError'] = "Enter valid City name"
		} else if(type == "state" && ((!value || value.length == 0))) {
			this.templateSchema[templateIndex]["data"]['stateError'] = "Enter valid State name"
		} else if(type == "zipcode" && ((!value || value.length == 0) || !zipCodeValidator.test(value))) {
			this.templateSchema[templateIndex]["data"]['zipcodeError'] = "Enter valid Zip"
		}
	}
}
